import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { Link, useNavigate } from "react-router-dom";

import {
  getTestSeriesList,
  testDelete,
  testList,
} from "../../../api/TestService";

import {
  closeModal,
  formatDate,
  ToastMain,
  SweetAlertShow,
  LoadingDiv,
} from "../../master/Master";

import Swal from "sweetalert2";
import { getSessions } from "../../../api/SessionsService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { excelimport } from "../../../api/MarketinService";
import TestLayout from "./TestLayout";
import { batchList } from "../../../api/Batch";

export default function Testsview() {
  const hasAccess = usePrivateLink();
  const navigate = useNavigate();

  const [List, setList] = useState([]);
  const [parent_id, setParentId] = useState(null);
  const [parent, setParent] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const [batch, setBatch] = useState([]);
  const [selectedBatchId, setSelectedBatchId] = useState("");

  const [search, setSearch] = useState("");

  const [Data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);
  const [responseMsg, setResponseMsg] = useState(null);
  const [error, setError] = useState("");

  const [sessions, setSessions] = useState([]);
  const [selectedSession, setSelectedSessions] = useState("");

  /* =========================================================
     FETCH TEST LIST
  ========================================================= */

  const fetchList = async () => {
    setLoading(true);

    const addUrl =
      `&page=${page}` +
      `&parent_id=${parent}` +
      `&batch_id=${selectedBatchId}` +
      `&search=${encodeURIComponent(search)}` +
      `&session_id=${selectedSession}`;

    try {
      const response = await testList(addUrl);

      if (response?.data?.status) {
        setList(response?.data?.data);
      } else {
        setList([]);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
  }, [search, selectedBatchId, parent, page, selectedSession]);

  /* =========================================================
     DELETE TEST
  ========================================================= */

  const handleTestDelete = async (id) => {
    setLoading(true);

    try {
      const response = await testDelete(id);

      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: "Deleted successfully!",
        });

        fetchList();
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     SESSION
  ========================================================= */

  const getSession = async () => {
    setLoading(true);

    try {
      const response = await getSessions();

      if (response?.data?.status) {
        const sessionList = response?.data?.data || [];

        const activeSession = sessionList.find(
          (session) => session.status === "1",
        );

        setSessions(sessionList);

        if (activeSession) {
          setSelectedSessions(activeSession.id);
        }
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
    fetchSeriesList();
  }, []);

  /* =========================================================
     BATCH
  ========================================================= */

  useEffect(() => {
    if (selectedSession) {
      batchliststudent();
    }
  }, [selectedSession]);

  const batchliststudent = async () => {
    if (!selectedSession) return;

    setLoading(true);

    try {
      const addUrl = `session_id=${selectedSession}`;

      const response = await batchList(addUrl);

      if (response?.data?.status) {
        setBatch(response?.data?.data || []);
      } else {
        setBatch([]);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     SERIES
  ========================================================= */

  const fetchSeriesList = async () => {
    setLoading(true);

    try {
      const response = await getTestSeriesList();

      if (response?.data?.status) {
        setData(response?.data?.data);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     RESET FILTERS
  ========================================================= */

  const handleResetFilters = () => {
    setSearch("");
    setParent("");
    setSelectedBatchId("");
    setPage(1);

    const activeSession = sessions.find((session) => session.status === "1");

    if (activeSession) {
      setSelectedSessions(activeSession.id);
    }
  };

  const activeFilterCount = [search, parent, selectedBatchId].filter(
    Boolean,
  ).length;

  /* =========================================================
     EXPORT
  ========================================================= */

  const handleDownload = async () => {
    try {
      let addUrl = `&page=${page}`;

      if (parent) addUrl += `&parent_id=${parent}`;
      if (selectedBatchId) {
        addUrl += `&batch_id=${selectedBatchId}`;
      }
      if (search) {
        addUrl += `&search=${encodeURIComponent(search)}`;
      }
      if (selectedSession) {
        addUrl += `&session_id=${selectedSession}`;
      }

      setLoading(true);

      let allData = [];

      const firstResponse = await testList(`${addUrl}&page=1`);

      const lastPage = firstResponse?.data?.data?.last_page || 1;

      for (let p = 1; p <= lastPage; p++) {
        const response = await testList(`${addUrl}&page=${p}`);

        const records = response?.data?.data?.data || [];

        allData.push(...records);
      }

      if (allData.length === 0) {
        SweetAlertShow(
          "info",
          "No Data",
          "There are no test records to export.",
        );

        return;
      }

      const formattedData = allData.map((item, index) => {
        let subjects = [];
        let subjectsMarks = [];

        try {
          subjects = JSON.parse(item.subjects || "[]");

          subjectsMarks = JSON.parse(item.subjects_marks || "[]");
        } catch (err) {
          console.warn("Error parsing subjects:", err);
        }

        return {
          SN: index + 1,
          Title: item.title || "",
          "Total Marks": item.total_marks || "",
          Subjects: subjects.join(", ") || "",
          "Subjects Marks": subjectsMarks.join(", ") || "",
          Date: item.date || "",
          "Series Title": item.series?.title || "N/A",
          "Series Type":
            item.series?.type === "0"
              ? "Minor"
              : item.series?.type === "1"
                ? "Major"
                : "N/A",
        };
      });

      const worksheet = XLSX.utils.json_to_sheet(formattedData);

      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Test_List");

      worksheet["!cols"] = Object.keys(formattedData[0]).map(() => ({
        wch: 25,
      }));

      const dateStr = new Date().toISOString().split("T")[0];

      XLSX.writeFile(workbook, `Test_List_${dateStr}.xlsx`);

      ToastMain.fire({
        icon: "success",
        title: `${allData.length} test records exported!`,
      });
    } catch (error) {
      console.error("Export error:", error);

      SweetAlertShow(
        "error",
        "Export Failed",
        error?.message || "Unable to export test records.",
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     EXCEL IMPORT
  ========================================================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const formData = new FormData(e.target);

    formData.append("file", file);

    try {
      const res = await excelimport(formData);

      if (res.data) {
        closeModal("statusChange");

        ToastMain.fire({
          icon: "success",
          title: "Uploaded successfully!",
        });
      } else {
        SweetAlertShow("info", "Warning", res?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     SAMPLE DOWNLOAD
  ========================================================= */

  const handleDummyDownload = () => {
    const data = [
      [
        "Name",
        "Father's Name",
        "Mobile",
        "Alternate No",
        "State",
        "District",
        "Block",
        "Village",
        "Tehsil",
        "Address",
        "Education Level",
        "Description",
      ],
      [
        "seema",
        "Ram",
        "1234567890",
        "9876543210",
        "Rajasthan",
        "jaipur",
        "amber",
        "chomu",
        "chomu",
        "House no.14",
        "12th Pass",
        "okkk",
      ],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(data);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(fileData, "Student-Template.xlsx");
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid py-3">
                <div className="row">
                  <TestLayout />

                  <div className="col-12">
                    {/* =====================================================
                        PAGE HEADER
                    ====================================================== */}

                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-body p-4">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                          <div className="d-flex align-items-center">
                            <div
                              className="bg-label-primary rounded-3 d-flex align-items-center justify-content-center me-3"
                              style={{
                                width: 48,
                                height: 48,
                                minWidth: 48,
                              }}
                            >
                              <i className="ri-file-list-3-line fs-3 text-primary"></i>
                            </div>

                            <div>
                              <h4 className="fw-bold mb-1">Tests</h4>

                              <p className="text-muted mb-0">
                                Manage tests, examinations and test series.
                              </p>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            {activeFilterCount > 0 && (
                              <span className="badge bg-label-primary rounded-pill px-3 py-2">
                                <i className="ri-filter-line me-1"></i>
                                {activeFilterCount} filter
                                {activeFilterCount > 1 ? "s" : ""} active
                              </span>
                            )}

                            {hasAccess("/tests/marks/export") && (
                              <button
                                type="button"
                                className="btn btn-outline-success"
                                onClick={handleDownload}
                                title="Export test list"
                              >
                                <i className="ri-file-excel-2-line me-1"></i>
                                Export
                              </button>
                            )}

                            {hasAccess("/tests/add_test") && (
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => navigate("/tests/add_test")}
                              >
                                <i className="ri-add-line me-1"></i>
                                Add New Test
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* =====================================================
                        FILTER CARD
                    ====================================================== */}

                    <div className="card border-0 shadow-sm mb-4">
                      <div className="card-body p-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-center">
                            <i className="ri-filter-3-line text-primary fs-5 me-2"></i>

                            <div>
                              <h6 className="fw-semibold mb-0">Filters</h6>

                              <small className="text-muted">
                                Find tests by session, batch, series or title.
                              </small>
                            </div>
                          </div>

                          {activeFilterCount > 0 && (
                            <button
                              type="button"
                              className="btn btn-sm btn-link text-danger p-0"
                              onClick={handleResetFilters}
                            >
                              <i className="ri-close-circle-line me-1"></i>
                              Clear Filters
                            </button>
                          )}
                        </div>

                        <div className="row g-3">
                          {/* Session */}

                          <div className="col-xl-3 col-md-6">
                            <label className="form-label small fw-semibold mb-1">
                              Session
                            </label>

                            <select
                              className="form-select"
                              value={selectedSession}
                              onChange={(e) => {
                                setSelectedSessions(e.target.value);

                                setSelectedBatchId("");

                                setPage(1);
                              }}
                            >
                              <option value="">All Sessions</option>

                              {sessions.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.session}
                                  {item.status === "1" ? " (Active)" : ""}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Batch */}

                          <div className="col-xl-3 col-md-6">
                            <label className="form-label small fw-semibold mb-1">
                              Batch
                            </label>

                            <select
                              name="batch_id"
                              className="form-select"
                              value={selectedBatchId}
                              onChange={(e) => {
                                setSelectedBatchId(e.target.value);

                                setPage(1);
                              }}
                            >
                              <option value="">All Batches</option>

                              {batch?.map((item, i) => {
                                const courseTitle = item?.course?.title || "";

                                const shortCourseTitle =
                                  courseTitle.length > 20
                                    ? courseTitle.substring(0, 20) + "..."
                                    : courseTitle;

                                return (
                                  <option key={item?.id || i} value={item?.id}>
                                    {item?.title}
                                    {courseTitle
                                      ? ` (${shortCourseTitle})`
                                      : ""}
                                  </option>
                                );
                              })}
                            </select>
                          </div>

                          {/* Series */}

                          <div className="col-xl-3 col-md-6">
                            <label className="form-label small fw-semibold mb-1">
                              Test Series
                            </label>

                            <select
                              className="form-select"
                              value={parent}
                              onChange={(e) => {
                                setParent(e.target.value);

                                setPage(1);
                              }}
                            >
                              <option value="">All Series</option>

                              {Data?.data?.map((ser) => (
                                <option key={ser.id} value={ser.id}>
                                  {ser.title}
                                </option>
                              ))}
                            </select>
                          </div>

                          {/* Search */}

                          <div className="col-xl-3 col-md-6">
                            <label className="form-label small fw-semibold mb-1">
                              Search
                            </label>

                            <div className="input-group">
                              <span className="input-group-text">
                                <i className="ri-search-line"></i>
                              </span>

                              <input
                                type="search"
                                name="search"
                                className="form-control"
                                placeholder="Search test..."
                                value={search}
                                onChange={(e) => {
                                  setSearch(e.target.value);

                                  setPage(1);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* =====================================================
                        TEST LIST
                    ====================================================== */}

                    <div className="card border-0 shadow-sm">
                      {/* List Header */}

                      <div className="card-body border-bottom py-3 px-4">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                          <div className="d-flex align-items-center">
                            <div
                              className="bg-label-primary rounded-2 d-flex align-items-center justify-content-center me-2"
                              style={{
                                width: 36,
                                height: 36,
                              }}
                            >
                              <i className="ri-file-list-3-line text-primary"></i>
                            </div>

                            <div>
                              <h5 className="fw-semibold mb-0">Test List</h5>

                              <small className="text-muted">
                                {List?.total || 0} tests found
                              </small>
                            </div>
                          </div>

                          {activeFilterCount === 0 && (
                            <span className="badge bg-label-secondary rounded-pill">
                              All Tests
                            </span>
                          )}
                        </div>
                      </div>

                      {/* Table */}

                      <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                          <thead>
                            <tr>
                              <th
                                className="ps-4"
                                style={{
                                  width: 70,
                                }}
                              >
                                #
                              </th>

                              <th>Test</th>

                              <th>Marks</th>

                              <th>Date</th>

                              <th>Series</th>

                              <th>Type</th>

                              <th
                                className="text-center pe-4"
                                style={{
                                  width: 150,
                                }}
                              >
                                Actions
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {List?.data?.length > 0 ? (
                              List.data.map((item, index) => (
                                <tr key={item.id || index}>
                                  {/* Number */}

                                  <td className="ps-4">
                                    <span className="text-muted fw-medium">
                                      {String(
                                        (List?.from || 1) + index,
                                      ).padStart(2, "0")}
                                    </span>
                                  </td>

                                  {/* Test */}

                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div
                                        className="bg-label-primary rounded-2 d-flex align-items-center justify-content-center me-3"
                                        style={{
                                          width: 38,
                                          height: 38,
                                          minWidth: 38,
                                        }}
                                      >
                                        <i className="ri-file-text-line text-primary"></i>
                                      </div>

                                      <div>
                                        <h6 className="mb-1 fw-semibold">
                                          {item?.title || "Untitled Test"}
                                        </h6>

                                        {item?.series?.title && (
                                          <small className="text-muted">
                                            {item.series.title}
                                          </small>
                                        )}
                                      </div>
                                    </div>
                                  </td>

                                  {/* Marks */}

                                  <td>
                                    <span className="fw-semibold">
                                      {item?.total_marks ?? 0}
                                    </span>
                                  </td>

                                  {/* Date */}

                                  <td>
                                    <div className="d-flex align-items-center">
                                      <i className="ri-calendar-line text-muted me-2"></i>

                                      <span>
                                        {item?.date
                                          ? formatDate(item.date)
                                          : "—"}
                                      </span>
                                    </div>
                                  </td>

                                  {/* Series */}

                                  <td>
                                    {item?.parent_id == null ? (
                                      <span className="badge bg-label-secondary rounded-pill">
                                        Without Series
                                      </span>
                                    ) : (
                                      <span className="badge bg-label-success rounded-pill">
                                        With Series
                                      </span>
                                    )}
                                  </td>

                                  {/* Type */}

                                  <td>
                                    {item?.series?.type === "1" ? (
                                      <span className="badge bg-label-warning rounded-pill">
                                        <i className="ri-medal-line me-1"></i>
                                        Exam
                                      </span>
                                    ) : (
                                      <span className="badge bg-label-primary rounded-pill">
                                        <i className="ri-file-edit-line me-1"></i>
                                        Test
                                      </span>
                                    )}
                                  </td>

                                  {/* Actions */}

                                  <td className="text-end pe-4">
                                    <div className="d-flex justify-content-end gap-2">
                                      {hasAccess("/tests/report") && (
                                        <Link
                                          to={`/tests/report?id=${item.id}`}
                                          className="btn btn-sm btn-icon btn-outline-success"
                                          title="View Report"
                                        >
                                          <i className="ri-eye-line"></i>
                                        </Link>
                                      )}

                                      {hasAccess("/tests/update_test") && (
                                        <Link
                                          to="/tests/update_test"
                                          state={{
                                            item: item,
                                          }}
                                          className="btn btn-sm btn-icon btn-outline-primary"
                                          title="Edit Test"
                                        >
                                          <i className="ri-edit-line"></i>
                                        </Link>
                                      )}

                                      {hasAccess("/tests/delete") && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-icon btn-outline-danger"
                                          title="Delete Test"
                                          onClick={() => {
                                            Swal.fire({
                                              title: "Delete test?",
                                              text: `Are you sure you want to delete "${item?.title}"? This action cannot be undone.`,
                                              icon: "warning",
                                              showCancelButton: true,
                                              confirmButtonColor: "#d33",
                                              cancelButtonColor: "#6c757d",
                                              confirmButtonText:
                                                "Yes, delete it",
                                              cancelButtonText: "Cancel",
                                            }).then((result) => {
                                              if (result.isConfirmed) {
                                                handleTestDelete(item.id);
                                              }
                                            });
                                          }}
                                        >
                                          <i className="ri-delete-bin-line"></i>
                                        </button>
                                      )}

                                      {hasAccess("/tests/syllabus") && (
                                        <Link
                                          to={`/tests/syllabus?id=${item.id}`}
                                          className="btn btn-sm btn-icon btn-outline-info"
                                          title="Exam Syllabus"
                                        >
                                          <i className="ri-book-open-line"></i>
                                        </Link>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              /* EMPTY STATE */

                              <tr>
                                <td colSpan="7" className="text-center">
                                  <div className="py-5">
                                    <div
                                      className="bg-label-primary rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                                      style={{
                                        width: 70,
                                        height: 70,
                                      }}
                                    >
                                      <i className="ri-file-search-line fs-1 text-primary"></i>
                                    </div>

                                    <h5 className="fw-semibold mb-2">
                                      No Tests Found
                                    </h5>

                                    <p className="text-muted mb-3">
                                      {activeFilterCount > 0
                                        ? "No tests match the selected filters."
                                        : "There are no tests available yet."}
                                    </p>

                                    {activeFilterCount > 0 && (
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary"
                                        onClick={handleResetFilters}
                                      >
                                        <i className="ri-refresh-line me-1"></i>
                                        Clear Filters
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* =================================================
                          PAGINATION
                      ================================================== */}

                      {List?.total > 0 && (
                        <div className="border-top px-4 py-3">
                          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                            <div className="text-muted small">
                              Showing <strong>{List?.from || 0}</strong> to{" "}
                              <strong>{List?.to || 0}</strong> of{" "}
                              <strong>{List?.total || 0}</strong> tests
                            </div>

                            <nav>
                              <ul className="pagination pagination-sm mb-0">
                                {List?.links?.map((btn, i) => {
                                  const isFirst = i === 0;

                                  const isLast = i === List?.links?.length - 1;

                                  return (
                                    <li
                                      key={i}
                                      className={`page-item ${
                                        btn?.active ? "active" : ""
                                      } ${!btn?.url ? "disabled" : ""}`}
                                    >
                                      <button
                                        type="button"
                                        className="page-link"
                                        onClick={() => {
                                          if (!btn?.url) return;

                                          if (isLast) {
                                            setPage(List.current_page + 1);
                                          } else if (isFirst) {
                                            setPage(List.current_page - 1);
                                          } else {
                                            setPage(Number(btn.label));
                                          }
                                        }}
                                      >
                                        {isFirst ? (
                                          <i className="ri-arrow-left-line"></i>
                                        ) : isLast ? (
                                          <i className="ri-arrow-right-line"></i>
                                        ) : (
                                          btn.label
                                        )}
                                      </button>
                                    </li>
                                  );
                                })}
                              </ul>
                            </nav>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>

      {/* =========================================================
          EXCEL IMPORT MODAL
      ========================================================== */}

      {showModal && (
        <div
          className="modal show fade d-block"
          tabIndex="-1"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <div>
                    <h5 className="modal-title fw-bold mb-1">
                      Import Test Marks
                    </h5>

                    <small className="text-muted">
                      Upload test marks using an Excel file.
                    </small>
                  </div>

                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>

                <div className="modal-body p-4">
                  {responseMsg && (
                    <div
                      className={`alert alert-${
                        responseMsg.type === "error" ? "danger" : "success"
                      }`}
                    >
                      {responseMsg.text}
                    </div>
                  )}

                  {/* Template */}

                  <div className="bg-label-primary rounded-3 p-3 mb-4">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <i className="ri-file-excel-2-line text-primary fs-4 me-2"></i>

                        <div>
                          <h6 className="mb-1 fw-semibold">Excel Template</h6>

                          <small className="text-muted">
                            Download the sample format first.
                          </small>
                        </div>
                      </div>

                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={handleDummyDownload}
                      >
                        <i className="ri-download-line me-1"></i>
                        Download
                      </button>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Session</label>

                    <select className="form-select" name="session_id">
                      <option value="">Select Session</option>

                      {sessions.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.session}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Source</label>

                    <select
                      name="source_id"
                      className="form-select"
                      defaultValue=""
                    >
                      <option value="" disabled>
                        Select Source
                      </option>
                    </select>
                  </div>

                  <div>
                    <label className="form-label">Excel File</label>

                    <input
                      type="file"
                      className="form-control"
                      accept=".xlsx,.xls"
                      onChange={(e) => setFile(e.target.files[0])}
                      required
                    />

                    <small className="text-muted">
                      Supported formats: .xlsx, .xls
                    </small>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Uploading...
                      </>
                    ) : (
                      <>
                        <i className="ri-upload-2-line me-1"></i>
                        Upload
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
